<script setup lang="ts">
import {computed} from "vue";
import {Bot} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";
import {BirthdayGift, GiftSendHour} from "@/birthday-gift/interfaces";

const props = defineProps<{
    gifts: BirthdayGift[];
    sendHour: GiftSendHour;
}>();

const emit = defineEmits<{
    (e: 'open-today'): void;
}>();

const autoCount = computed(() => props.gifts.filter((gift) => gift.active && gift.auto_send).length);

const hourLabel = computed(() => `${String(props.sendHour).padStart(2, '0')}:00`);

const hint = computed(() => autoCount.value > 0
    ? `Ils partent seuls à ${hourLabel.value}, avec le cadeau correspondant au profil du patient.`
    : 'Aucun envoi automatique : vous validez chaque message depuis les anniversaires du jour.');
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-3 rounded-lg bg-white p-4 shadow">
    <div class="flex min-w-0 items-center gap-3">
      <Bot class="h-6 w-6 shrink-0 text-primary" />
      <div class="min-w-0">
        <div class="text-sm font-semibold">
          {{ autoCount }} cadeau{{ autoCount > 1 ? 'x' : '' }} en envoi automatique
        </div>
        <div class="text-xs leading-relaxed text-muted-foreground">
          {{ hint }}
        </div>
      </div>
    </div>
    <Button
      variant="ghost"
      size="sm"
      @click="emit('open-today')"
    >
      Voir les envois du jour
    </Button>
  </div>
</template>
